<div class="text-align-center display-flex flex-direction-column">
  <h3 class="t-5@r color-void mb-4">Photo Disapproved</h3>
  <div class="t-8@r color-ash mb-6">No nudity or unacceptable images are allowed to be sent.</div>
  <button sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="close()">Close</button>
</div>
